// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-data-content[data-v-d38c8e7e]{width:100%;min-height:550px;background-color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#6b768b}.no-data-content>div+div[data-v-d38c8e7e]{margin-top:10px}.reset-filters[data-v-d38c8e7e]{color:#0f2345;cursor:pointer;text-decoration:underline;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none;text-decoration-skip:none;-webkit-text-decoration-skip:none}", ""]);
// Exports
module.exports = exports;
